export default __webpack_public_path__ + "static/media/armoire_a_jeu.20d508c1.jpg";